import {ReactElement} from 'react'
import {Moment} from 'moment-timezone'
import {Trans, Translation} from 'react-i18next'
import {TranslateT} from '.'

// Returns a `Translation` that more closely aligns with our usage
export function SafeTranslation(props: {
  children: (t: TranslateT) => ReactElement
  ns?: string
}): ReactElement {
  return <Translation {...props} />
}
// Returns a `Trans` that more closely aligns with our usage
export function SafeTrans(props: {
  i18nKey: string
  count?: number
  t?: TranslateT
  components?: readonly ReactElement[] | {readonly [tagName: string]: ReactElement}
  values?: Record<string, string | number | boolean | Moment>
}) {
  // @ts-ignore You can pass a custom `t` but `Trans` doesn't like that
  return <Trans {...props} />
}
